import { connect } from 'react-redux';
import PlayerListContent from './PlayerListContent';
import PlayerActions from '../../../../actions/player';

export default connect(
  ({ player }) =>({
    players: player.list.map(id => player.items[id]),
    playersLoading: player.loading
  }),
  dispatch => ({
    lazyLoadPlayers: () => dispatch(PlayerActions.loadLazyItems())
  })
)(PlayerListContent);



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/PlayerListContent/index.js